module.exports = __webpack_public_path__ + "img/devbg.f24f622d.png";